import React from 'react';
import LeftSide from './components/LeftSide';
import backgroundImage from 'Assets/img/sign/right-background@3x.png';
import phone1 from 'Assets/img/sign/phone.png';
import phone2 from 'Assets/img/sign/phone@2x.png';
import phone3 from 'Assets/img/sign/phone@3x.png';
import phoneVi1 from 'Assets/img/sign/phone_vi.png';
import phoneVi2 from 'Assets/img/sign/phone_vi@2x.png';
import phoneVi3 from 'Assets/img/sign/phone_vi@3x.png';
import icGooglePlay1 from 'Assets/img/sign/ic_google_play.png';
import icGooglePlay2 from 'Assets/img/sign/ic_google_play@2x.png';
import icGooglePlay3 from 'Assets/img/sign/ic_google_play@3x.png';
import icAppStore1 from 'Assets/img/sign/ic_app_store.png';
import icAppStore2 from 'Assets/img/sign/ic_app_store@2x.png';
import icAppStore3 from 'Assets/img/sign/ic_app_store@3x.png';
import { getImageSet } from 'Util/DataUtils';
import LoadingView from 'Components/common/LoadingView';
import { useSelector } from 'react-redux';
import OvalButton from './components/common/OvalButton';
import CommonDialog from 'Components/Popup/CommonDialog';

const phone = getImageSet([phone1, phone2, phone3]);
const phoneVi = getImageSet([phoneVi1, phoneVi2, phoneVi3]);
const icGooglePlay = getImageSet([icGooglePlay1, icGooglePlay2, icGooglePlay3]);
const icAppStore = getImageSet([icAppStore1, icAppStore2, icAppStore3]);

// 앱 다운로드
const GOOGLE = 'GOOGLE';
const APPLE = 'APPLE';
const APPLE_VI = 'APPLE_VI';
const storeLink = {
  GOOGLE: 'https://play.google.com/store/apps/details?id=com.naya',
  APPLE: 'https://apps.apple.com/kr/app/%EC%9D%B8%ED%85%8C%EB%A6%AC%EC%96%B4-%EC%82%AC%EC%97%85%EC%9E%90%EB%A5%BC-%EC%9C%84%ED%95%9C-%ED%94%8C%EB%9E%AB%ED%8F%BC-%EB%82%98%EC%95%BC/id1608904337',
  APPLE_VI: 'https://apps.apple.com/vn/app/%EC%9D%B8%ED%85%8C%EB%A6%AC%EC%96%B4-%EC%82%AC%EC%97%85%EC%9E%90%EB%A5%BC-%EC%9C%84%ED%95%9C-%ED%94%8C%EB%9E%AB%ED%8F%BC-%EB%82%98%EC%95%BC/id1608904337',
};

const handleDownloadClick = type => {
  window.open(storeLink[type], '_blank');
};

const SignIn = () => {
  const { isLoading, dialogData } = useSelector(state => state.loading);
  const { locale } = useSelector(state => state.settings.locale);
  return (
    <div className="sign-in-wrapper">
      <LeftSide />
      <div className="right-container">
        <div
          className="download-wrapper"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        >
          <div className="download-button-wrapper">
            <OvalButton
              label="signIn.appDownload.google"
              onClick={() => {
                handleDownloadClick(GOOGLE);
              }}
              iconSet={icGooglePlay}
            />
            <OvalButton
              label="signIn.appDownload.apple"
              onClick={() => {
                handleDownloadClick(locale === 'vi' ? APPLE_VI : APPLE);
              }}
              iconSet={icAppStore}
            />
          </div>
          <img className="download-phone-image" {...(locale === 'vi' ? phoneVi : phone)} alt="phone" />
        </div>
      </div>
      <LoadingView isLoading={isLoading} />
      <CommonDialog {...dialogData} />
    </div>
  );
};

export default SignIn;
